import React, { MouseEvent } from 'react';
import styled from 'styled-components';
import Button from '@fenderdigital/ui/Button';
import { ArrowLeft } from '@fenderdigital/ui/Icons';
import Spacer from '@fenderdigital/ui/Spacer';
import useBackHandler from './useBackHandler';

interface BackButtonWrapperProps {
  isMobile?: boolean;
}

export const BackButtonWrapper = styled.div<BackButtonWrapperProps>`
  padding-top: ${({ isMobile }): string => (isMobile ? '2rem' : '0')};
`;

const BackButtonContainer = styled.div`
  button {
    background-color: transparent;
    font-family: ${({ theme: { fonts } }): string => fonts.sourceSans};
    font-size: ${({ theme: { fontSizes } }): string => fontSizes.f3};
    text-transform: none;
  }
`;

const StyledArrowLeft = styled(ArrowLeft)`
  fill: ${({ theme: { colors } }): string => colors.midGray};
  max-width: 0.85rem;
`;

interface BackButtonProps {
  label?: string;
  onClick?: (e?: MouseEvent<HTMLButtonElement>) => void;
  preventDefaultBack?: boolean;
}

const BackButton: React.FC<BackButtonProps> = ({
  label = 'Back',
  onClick = (): void => {},
  preventDefaultBack = false,
}) => {
  const backHandler = useBackHandler(onClick);

  return (
    <BackButtonContainer>
      <Button
        dataId="back-button"
        variant="outline"
        shape="pill"
        size="small"
        colorScheme="lightGray"
        textColor="black"
        leftIcon={<StyledArrowLeft aria-hidden />}
        onClick={preventDefaultBack ? onClick : backHandler}
      >
        {label}
      </Button>
      <Spacer spacing="sm3" />
    </BackButtonContainer>
  );
};

export default BackButton;
